module.exports = __webpack_public_path__ + "static/features_main-1a2e5ac224f490a87b6d27c60dc8eaf7.png";